// extracted by mini-css-extract-plugin
module.exports = {"root":"tweetStatistic_root__1HhRd","child":"tweetStatistic_child__3WPpm"};